import { render, staticRenderFns } from "./cartera.vue?vue&type=template&id=44eea088&scoped=true"
import script from "./cartera.vue?vue&type=script&lang=js"
export * from "./cartera.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44eea088",
  null
  
)

export default component.exports